import React, { useEffect, useState, useContext, useRef, useMemo } from "react";
import { BASELINE, AFTER_LOGIN } from "../../util/index";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import { toast } from "react-hot-toast";
import Dashboard from "./Index";
import Select from 'react-select'
import { motion } from "framer-motion";
import PaginatedTable from "./T_pag_table";
import RandomSATReady from "./SAT/Dashboard_SAT";
import GetHelp from "./get_help";
import Modal from 'react-modal';
import { FaRegNoteSticky } from "react-icons/fa6";
import { FaRegFrownOpen } from "react-icons/fa";
import { FaTimes } from "react-icons/fa";
import CourseCard from "./CourseCard";
import MyClassManagement from "./MyClassManagement";
import CreateClassModal from "./CreateClassModal";
import { FaAnglesRight } from "react-icons/fa6";
import { FaAnglesLeft } from "react-icons/fa6";
import SettingModal from "./setting";
import { FiBook, FiUsers, FiFileText, FiSettings, FiLogOut, FiLock, FiStar, FiPlusCircle, FiGrid, FiCheck } from "react-icons/fi";

const detectTestSubject = (test) => {
  try {
    const setting = test.Setting ? JSON.parse(test.Setting) : null;
    if (setting?.mode) {
      const m = setting.mode.toLowerCase();
      if (m.includes('math')) return 'Math';
      if (m.includes('read') || m.includes('writ') || m.includes('eng')) return 'English';
    }
  } catch {}
  const name = (test.name || '').toLowerCase();
  if (name.includes('math')) return 'Math';
  if (name.includes('read') || name.includes('writ') || name.includes('eng')) return 'English';
  return '';
};

const TDashboard = () => {
  const { logoutUser, user } = useContext(UserContext);
  const boxItemLeftRef = useRef();
  const navigate = useNavigate();
  const { classid: urlClassId } = useParams();
  const [classlst, setclasslst] = useState([]);
  const [studentId, setStudentId] = useState('');
  const [selectedClass, setSelectedClass] = useState('');
  const [table, settable] = useState([]);
  const [isAddStudentOpen, setIsAddStudentOpen] = useState(false);
  const [isDashboardOpen, setIsDashboardOpen] = useState(false);
  const [selectedStudentId, setSelectedStudentId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [savedquizmodel, setsavedquizmodel] = useState(false);
  const [notes, setnotes] = useState([]);
  const [autosave, setautosave] = useState([]);

  const [quiztitle, setquiztitle] = useState('');
  const [quizgroup, setquizgroup] = useState([]);
  const [quizid, setquizid] = useState('');
  const [quizview, setquizview] = useState(false);
  const [quiz_type, setquiz_type] = useState('');

  const [questionid, setQuestionid] = useState('');
  const [tag, settag] = useState('');
  const [viewmodule, setviewmodule] = useState(false);
  const [viewmodule2, setviewmodule2] = useState(false);

  const [selectedTopic, setSelectedTopic] = useState([]);
  const [Open, SetOpen] = useState(false);
  const [password, setPassword] = useState('');

  const [sname, setsname] = useState('');
  const [nameSearchTerm, setNameSearchTerm] = useState('');
  const [usersearch, setusersearch] = useState([]);
  const [testDuration, setTestDuration] = useState(0);

  const [hideExplanation, setHideExplanation] = useState(false);
  const [section, setsection] = useState(9);
  const [selectedOption, setSelectedOption] = useState('totalQuestions');
  const [correctnessSort, setCorrectnessSort] = useState(null); // null | 'asc' | 'desc'
  const [getstudentsscores, setgetstudentsscores] = useState([]);
  const [selectedTest, setSelectedTest] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const studentsPerPage = 5;

  const indexOfLastStudent = currentPage * studentsPerPage;
  const indexOfFirstStudent = indexOfLastStudent - studentsPerPage;
  const currentStudents = Array.isArray(table)
    ? table.slice(indexOfFirstStudent, indexOfLastStudent)
    : [];
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const [currentPage2, setCurrentPage2] = useState(1);
  const quizzesPerPage = 5;

  const [folders, setFolders] = useState({});
  const [isAllNotes, setIsAllNotes] = useState(false);

  const [loading, setLoading] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [helpsession, sethelpsession] = useState(false);
  const [isPremiumModalOpen, setIsPremiumModalOpen] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [isCouponValid, setIsCouponValid] = useState(null);
  const [isVerifying, setIsVerifying] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [quizdata, setquizdata] = useState({ questions: [], qanswers: [], qbookmarks: [], qrealanswers: [], qskillsets: [] });
  const [isOpen2, setIsOpen2] = useState(false);
  const [selectstudent, setselectstudent] = useState("");

  const validCouponCodes = ['MMTFREE3MONTHS'];
  const [isExpanded, setIsExpanded] = useState(false);

  const filteredQuizzes = autosave.filter((test) => {
    return (
      test.quiz_group &&
      test.quiz_group.some((groupItem) => groupItem.class_name === selectedClass.class_name)
    );
  });

  const filteredLength = filteredQuizzes.length;
  const indexOfLastQuiz = currentPage2 * quizzesPerPage;
  const indexOfFirstQuiz = indexOfLastQuiz - quizzesPerPage;
  const currentQuizzes = filteredQuizzes.slice(indexOfFirstQuiz, indexOfLastQuiz);
  const currentQuizzes2 = autosave.slice(indexOfFirstQuiz, indexOfLastQuiz);

  function onLogout() {
    logoutUser();
    axios.post(BASELINE + 'user/logout', {})
      .then(() => window.location.replace(AFTER_LOGIN))
      .catch((error) => alert(error));
  }

  const handleVerifyCoupon = async () => {
    setIsVerifying(true);
    setTimeout(() => {
      if (validCouponCodes.includes(couponCode)) {
        setIsCouponValid(true);
        handlePremiumActivation();
      } else {
        setIsCouponValid(false);
      }
      setIsVerifying(false);
    }, 1000);
  };

  const handlePremiumActivation = () => {
    const today = new Date();
    const startPremiumDate = today.toISOString().split('T')[0];
    const endPremiumDate = new Date();
    endPremiumDate.setMonth(endPremiumDate.getMonth() + 3);
    const endPremiumDateString = endPremiumDate.toISOString().split('T')[0];
    const premiumData = { u_id: user.u_id, start_date: startPremiumDate, end_date: endPremiumDateString };
    axios.post(BASELINE + 'premium/activate', premiumData)
      .then(() => { alert("Premium service activated!"); setIsPremiumModalOpen(false); window.location.reload(); })
      .catch((error) => { console.error(error); alert("Error activating premium service."); });
  };

  const handleCopyClassId = (id) => {
    navigator.clipboard.writeText(id)
      .then(() => toast.success('Class ID copied to clipboard!'))
      .catch(() => toast.error('Failed to copy Class ID'));
  };

  useEffect(() => {
    if (quizdata.questions && quizdata.questions.length > 0 && currentIndex >= 0) {
      const question = quizdata.questions[currentIndex];
      handleButtonClick(question, quiz_type, question.section);
    }
  }, [currentIndex, quizdata.questions]);

  const handleNextQuestion = () => {
    if (currentIndex < quizdata.questions.length - 1) setCurrentIndex(currentIndex + 1);
  };

  const handlePreviousQuestion = () => {
    if (currentIndex > 0) setCurrentIndex(currentIndex - 1);
  };

  const paginate2 = (pageNumber) => setCurrentPage2(pageNumber);

  const fetchPdfs = async () => {
    try {
      const response = await axios.get(`${BASELINE}digital/sat/answers/allnotes`);
      if (Array.isArray(response.data)) {
        setIsAllNotes(true);
        setFolders({ allnotes: response.data });
      } else {
        setIsAllNotes(false);
        setFolders(response.data);
      }
    } catch (error) {
      console.error("Error fetching PDF files:", error);
    }
  };

  useEffect(() => { fetchPdfs(); }, []);

  const get_quiz_view = (testid) => {
    axios.post(`${BASELINE}tests/getstudents`, [testid])
      .then((response) => {
        const allResults = response.data.testId;
        if (!selectedClass.classid) {
          setgetstudentsscores(allResults);
        } else {
          setgetstudentsscores(allResults.filter(item => item.classid === selectedClass.classid));
        }
      })
      .catch(console.error);
  };

  const handleClick = (option) => setSelectedOption(option);
  const modulehandleChange = () => setHideExplanation(!hideExplanation);
  const handlePasswordChange = (event) => setPassword(event.target.value);

  const handleNameSearchChange = (event) => {
    setNameSearchTerm(event.target.value);
    axios.get(`${BASELINE}user/search/name/${event.target.value}`)
      .then((response) => setusersearch(response.data))
      .catch(console.error);
  };

  const handleSubmit2 = () => {
    if (password.length < 6) { alert("Password must be at least 6 characters long."); return; }
    axios.post(BASELINE + 'user/setpassword', [sname, password])
      .then(() => { setPassword(''); setsname(''); setNameSearchTerm(''); alert("Password Reset Successfully!"); })
      .catch(() => alert("Something Went Wrong."));
    SetOpen(false);
  };

  function logout() {
    logoutUser();
    axios.post(BASELINE + 'user/logout', {})
      .then(() => window.location.replace(AFTER_LOGIN))
      .catch((error) => alert(error));
  }

  useEffect(() => {
    const script2 = document.createElement('script');
    script2.src = 'https://cdn.jsdelivr.net/npm/katex@0.16.9/dist/contrib/auto-render.min.js';
    script2.integrity = 'sha384-+VBxd3r6XgURycqtZ117nYw44OOcIax56Z4dCRWbxyPt0Koah1uHoK0o4+/RRE05';
    script2.crossOrigin = 'anonymous';
    script2.onload = () => {
      if (boxItemLeftRef.current) {
        window.renderMathInElement(boxItemLeftRef.current, {
          delimiters: [
            { left: '$$', right: '$$', display: false },
            { left: "$", right: "$", display: false },
            { left: '\\(', right: '\\)', display: false },
            { left: '\\[', right: '\\]', display: true },
            { left: '\\begin{array}', right: '\\end{array}', display: true }
          ],
          throwOnError: false,
        });
      }
    };
    document.body.appendChild(script2);
    return () => { document.body.removeChild(script2); };
  }, [selectedTopic, hideExplanation]);

  function fetchAutoSaveData() {
    if (user) {
      setautosave([]);
      axios.get(BASELINE + 'getautosave', { params: { id: user.u_id } })
        .then(response => setautosave(response.data.data))
        .catch(console.error);
    }
  }

  useEffect(() => {
    if (!user || user.role !== 'teacher') navigate('/');
    fetchAutoSaveData();
  }, [user, navigate]);

  const fetchClassList = () => {
    if (!user) return;
    axios.post(BASELINE + "getclass", { params: { teacher_id: user.u_id } })
      .then((response) => setclasslst(response.data))
      .catch(console.error);
  };

  useEffect(() => { fetchClassList(); }, []);

  // URL에 classid가 있으면 classlst 로드 후 자동 선택
  useEffect(() => {
    if (urlClassId && classlst.length > 0) {
      const found = classlst.find(c => c.classid === urlClassId);
      if (found) {
        setSelectedClass(found);
        setsection(0);
      }
    }
  }, [urlClassId, classlst]);

  useEffect(() => {
    if (selectedClass.classid) {
      axios.post(BASELINE + 'getclassbyid', [{ classid: selectedClass.classid }])
        .then((response) => settable(response.data ?? []))
        .catch(() => {});
    }
  }, [selectedClass]);

  const generateShortId = () => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let result = '';
    for (let i = 0; i < 6; i++) result += characters.charAt(Math.floor(Math.random() * characters.length));
    return result;
  };

  const handleCreateClass = (newClassData, onSuccess) => {
    const shortId = generateShortId();
    const data = {
      teacher_id: user.u_id,
      class_name: newClassData.className,
      shortid: shortId,
      premium: user.premium,
      type: newClassData.type,
      level: newClassData.level,
      bg: newClassData.bg,
    };
    axios.post(BASELINE + "class", [data])
      .then((response) => {
        toast.success(`Class created with ID: ${shortId} - ${response.data.message}`);
        fetchClassList();
        if (onSuccess) onSuccess();
      })
      .catch((error) => {
        if (error.response?.data?.message) toast.error(`Failed to create class: ${error.response.data.message}`);
        else toast.error("Failed to create class. Please try again.");
      });
  };

  const handleChange = (event) => setStudentId(event.target.value);

  const handleSelectChange = (event) => {
    if (event.target.value.length > 10) setSelectedClass(JSON.parse(event.target.value));
  };

  const passwordhandleSubmit = () => {
    if (password.length < 6) { alert("Password must be at least 6 characters long."); return; }
    axios.post(BASELINE + 'user/setpassword', [user.u_id, password])
      .then(() => { setPassword(''); alert("Password Reset Successfully!"); })
      .catch(() => alert("Something Went Wrong."));
    setIsOpen(false);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!selectedClass.classid) { alert('Please select a class first.'); return; }
    const data = { classid: selectedClass.classid, studentid: studentId, shortid: selectedClass.shortid, owner: user.u_id };
    axios.post(BASELINE + 'classaddstudent', [data])
      .then((response) => {
        setStudentId('');
        if (response.data.data) settable(response.data.data);
        alert(response.data.message);
      })
      .catch(() => {});
  };

  const handleRemove = (studentId) => {
    if (window.confirm('Are you sure you want to remove this student from the class?')) {
      const data = { classid: selectedClass.classid, studentid: studentId };
      axios.post(BASELINE + 'classdelstudent', [data])
        .then((response) => {
          setStudentId('');
          if (response.data.data) settable(response.data.data);
          alert(response.data.message);
        })
        .catch(() => {});
    }
  };

  const handleViewDashboard = (studentId) => { setSelectedStudentId(studentId); setIsDashboardOpen(true); };
  const handleClose = () => { setIsAddStudentOpen(false); setIsDashboardOpen(false); };

  const handleRemoveClass = () => {
    if (window.confirm('Are you sure you want to remove this class?')) {
      const data = { classid: selectedClass.classid, owner: user.u_id };
      axios.post(BASELINE + 'classdel', [data])
        .then((response) => {
          setStudentId(''); settable([]); setclasslst(response.data); setsection(9); setSelectedClass('');
        })
        .catch(() => {});
    }
  };

  const getallnotes = () => {
    axios.get(BASELINE + 'questions/allnotes', [])
      .then((response) => setnotes(response.data))
      .catch(() => {});
  };

  useEffect(() => { getallnotes(); }, []);

  const handleviewproblem = (type, question_id) => {
    if (type === 'SAT') navigate(`/devpsat/${question_id}`);
    else if (type === 'ACT') navigate(`/devact/${question_id}`);
  };

  const handleremovenote = async (id) => {
    try {
      await axios.post(BASELINE + 'questions/remove/note/byqid', [{ q_id: id }]);
      getallnotes();
      toast.success("Note removed successfully.");
    } catch (error) {
      console.error(error);
      toast.error("Failed to remove note.");
    }
  };

  function handleSave() {
    axios.post(BASELINE + 'updateaudosavebyid', { group: quizgroup, name: quiztitle, test_id: quizid })
      .then(() => { toast.success('Quiz updated successfully'); fetchAutoSaveData(); })
      .catch(console.error);
    setsavedquizmodel(false);
  }

  const handleButtonClick = async (questionid, data, tag) => {
    setQuestionid(questionid);
    if (data === 'SAT') {
      try {
        let res = await axios.get(BASELINE + "questions/sat", { params: { id: [questionid] } });
        const raw = Array.isArray(res.data[0]) ? res.data[0] : Array.isArray(res.data) ? res.data : [res.data];
        let mappedQuestions = raw.map((question, idx) => ({
          ...question, index: idx, answered: false, bookMarked: false, crossedOutOptions: [], selectedOption: null
        }));
        if (mappedQuestions[0]) setSelectedTopic(mappedQuestions[0]);
      } catch (error) {
        toast.error(error.message);
        console.error(error);
      }
    }
    setviewmodule(true);
  };

  const handleRemoveQuiz = () => {
    if (window.confirm('Are you sure you want to remove this quiz?')) {
      axios.post(BASELINE + 'removeautosavequiz', { data: { test_id: quizid, user_id: user.u_id } })
        .then(() => { toast.success('Quiz removed successfully'); setsavedquizmodel(false); fetchAutoSaveData(); })
        .catch(console.error);
    }
  };

  const handleNavigate = (parsedData) => {
    if (parsedData) {
      if (window.confirm('Are you sure you want to navigate to another page?')) {
        localStorage.setItem('currentTest', parsedData);
        localStorage.setItem('type', quiz_type);
        navigate(`/sat/quiz`, { state: { data: { help: true, back: true } } });
      }
    }
  };

  function ensureQuizDataStructure(data) {
    const transed = JSON.parse(data);
    return {
      questions: transed.questions || [],
      qanswers: transed.qanswers || [],
      qbookmarks: transed.qbookmarks || [],
      qrealanswers: transed.qrealanswers || [],
      qskillsets: transed.qskillsets || []
    };
  }

  // ─── Sidebar nav item ───────────────────────────────────────────────────────
  const NavBtn = ({ label, icon: Icon, active, onClick, danger }) => (
    <button
      onClick={onClick}
      className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-all duration-200 ${
        danger
          ? 'text-red-400/70 hover:text-red-400 hover:bg-red-500/10'
          : active
          ? 'bg-blue-500/20 text-blue-300 border border-blue-500/20 shadow-sm shadow-blue-500/10'
          : 'text-white/85 hover:text-white hover:bg-white/[0.10]'
      }`}
    >
      {Icon && <Icon className="text-base flex-shrink-0" />}
      <span>{label}</span>
    </button>
  );

  // ─── Stat card ──────────────────────────────────────────────────────────────
  const StatCard = ({ label, value, sub, accent }) => (
    <div className={`relative bg-white/[0.07] border border-white/[0.15] backdrop-blur-sm rounded-2xl p-5 overflow-hidden group hover:bg-white/[0.11] hover:border-white/[0.22] transition-all duration-300`}>
      <div className={`absolute top-0 left-0 right-0 h-0.5 rounded-t-2xl ${accent}`} />
      <p className="text-white/65 text-xs font-semibold uppercase tracking-wider mb-2">{label}</p>
      <p className="text-white text-3xl font-bold">{value}</p>
      {sub && <p className="text-white/55 text-xs mt-1">{sub}</p>}
    </div>
  );

  // Correctness % per question index, derived from student results
  // Correct_questionIds stores full question objects with .questionIds; fall back to plain id if not an object
  const correctnessData = useMemo(() => {
    if (!quizdata?.questions?.length) return [];
    return quizdata.questions.map((qId) => {
      const key = String(qId);
      let correct = 0, attempted = 0;
      getstudentsscores.forEach(({ testresult }) => {
        try {
          const toId = (q) => String(q?.questionIds ?? q);
          const cIds = JSON.parse(testresult.Correct_questionIds || "[]").map(toId);
          const iIds = JSON.parse(testresult.Incorrect_questionIds || "[]").map(toId);
          if (cIds.includes(key)) { correct++; attempted++; }
          else if (iIds.includes(key)) { attempted++; }
        } catch { /* skip malformed result */ }
      });
      return attempted > 0 ? Math.round((correct / attempted) * 100) : null;
    });
  }, [quizdata, getstudentsscores]);

  const sortedQuestionIndices = useMemo(() => {
    const n = quizdata?.questions?.length || 0;
    const indices = Array.from({ length: n }, (_, i) => i);
    if (!correctnessSort) return indices;
    return [...indices].sort((a, b) => {
      const ca = correctnessData[a] ?? (correctnessSort === 'asc' ? 101 : -1);
      const cb = correctnessData[b] ?? (correctnessSort === 'asc' ? 101 : -1);
      return correctnessSort === 'asc' ? ca - cb : cb - ca;
    });
  }, [quizdata, correctnessSort, correctnessData]);

  return (
    <>
      {/* ── Sidebar ──────────────────────────────────────────────────────────── */}
      <div className="fixed top-0 left-0 w-[240px] h-screen bg-[#1c2537] border-r border-white/[0.15] z-50 flex flex-col overflow-y-auto">

        {/* Logo + user info */}
        <div className="px-5 pt-6 pb-5 border-b border-white/[0.12]">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-full bg-gradient-to-br from-blue-500/40 to-indigo-500/40 border border-white/10 flex items-center justify-center flex-shrink-0">
              <span className="text-white text-xs font-bold">{user?.first_name?.[0]}{user?.last_name?.[0]}</span>
            </div>
            <div className="min-w-0">
              <p className="text-white/90 text-sm font-semibold truncate">{user?.first_name} {user?.last_name}</p>
              {user?.premium === 1 ? (
                <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-blue-500/20 border border-blue-400/30 text-blue-300 text-[10px] font-semibold">
                  <FiStar className="text-[9px]" /> Premium
                </span>
              ) : (
                <span className="inline-flex px-2 py-0.5 rounded-full bg-white/8 text-white/35 text-[10px]">Free Trial</span>
              )}
            </div>
          </div>
        </div>

        {/* Nav */}
        <nav className="flex-1 px-3 py-4 space-y-0.5">
          <p className="px-3 pb-1.5 pt-0.5 text-[10px] uppercase tracking-widest text-white/60 font-semibold">Classes</p>

          {selectedClass === '' ? (
            <NavBtn label="Manage Classes" icon={FiGrid} active={section === 9} onClick={() => { setsection(9); setSelectedClass(''); navigate('/main/teacher'); }} />
          ) : (
            <NavBtn label={selectedClass.class_name} icon={FiUsers} active={section === 0} onClick={() => setsection(0)} />
          )}

          <NavBtn label="Create a SAT Test" icon={FiPlusCircle} active={section === 3} onClick={() => setsection(3)} />
          <NavBtn label="Saved Tests" icon={FiFileText} active={section === 8} onClick={() => setsection(8)} />

          {user?.email === 'seank@admin.com' && (
            <>
              <p className="px-3 pb-1.5 pt-3 text-[10px] uppercase tracking-widest text-white/60 font-semibold">Admin</p>
              <NavBtn label="User Management" icon={FiUsers} active={false} onClick={() => SetOpen(true)} />
              <NavBtn label="Reported Problems" icon={FiBook} active={section === 1} onClick={() => setsection(1)} />
              <NavBtn label="SAT Answers" icon={FiFileText} active={section === 2} onClick={() => setsection(2)} />
            </>
          )}
        </nav>

        {/* Bottom actions */}
        <div className="px-3 pb-5 pt-3 border-t border-white/[0.12] space-y-0.5">
          {!user?.premium && (
            <button
              onClick={() => setIsPremiumModalOpen(true)}
              className="w-full mb-2 py-2.5 rounded-xl text-sm font-bold bg-gradient-to-r from-blue-600 to-indigo-600 text-white hover:from-blue-500 hover:to-indigo-500 shadow-lg shadow-blue-500/20 transition-all duration-200 active:scale-[0.98]"
            >
              Go Premium
            </button>
          )}
          <NavBtn label="Settings" icon={FiSettings} active={false} onClick={() => setIsOpen2(true)} />
          <NavBtn label="Password Reset" icon={FiLock} active={false} onClick={() => setIsOpen(true)} />
          <NavBtn label="Logout" icon={FiLogOut} active={false} onClick={logout} danger />
        </div>
      </div>

      {/* ── Main content ─────────────────────────────────────────────────────── */}
      <div
        className="ml-[240px] min-h-screen bg-[#0f1523]"
        ref={boxItemLeftRef}
      >

        {/* User Management Modal (admin) */}
        {Open && (
          <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/60 backdrop-blur-sm px-4">
            <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }}
              className="relative w-full max-w-2xl bg-[#111827] border border-white/[0.10] rounded-2xl shadow-2xl overflow-hidden">
              <div className="px-6 py-5 border-b border-white/[0.15]">
                <h3 className="text-lg font-bold text-white">User Management</h3>
              </div>
              <div className="p-6">
                <div className="flex gap-3 mb-4">
                  <input
                    type="text"
                    placeholder="Search by name…"
                    value={nameSearchTerm}
                    onChange={handleNameSearchChange}
                    className="flex-1 bg-white/[0.05] border border-white/[0.10] rounded-xl px-4 py-2.5 text-sm text-white placeholder-white/30 focus:outline-none focus:border-blue-400/50"
                  />
                </div>
                <div className="overflow-x-auto rounded-xl border border-white/[0.15]">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="bg-white/[0.07] text-white/65 text-xs uppercase tracking-wider">
                        <th className="px-4 py-3 text-left font-semibold">First Name</th>
                        <th className="px-4 py-3 text-left font-semibold">Last Name</th>
                        <th className="px-4 py-3 text-left font-semibold">Email</th>
                        <th className="px-4 py-3 text-left font-semibold">User ID</th>
                        <th className="px-4 py-3 text-left font-semibold">Select</th>
                      </tr>
                    </thead>
                    <tbody>
                      {usersearch.map((u, i) => (
                        <tr key={i} className="border-t border-white/[0.12] hover:bg-white/[0.07] transition-colors">
                          <td className="px-4 py-3 text-white/70">{u.first_name}</td>
                          <td className="px-4 py-3 text-white/70">{u.last_name}</td>
                          <td className="px-4 py-3 text-white/70">{u.email}</td>
                          <td className="px-4 py-3 text-white/70">{u.u_id}</td>
                          <td className="px-4 py-3">
                            <button onClick={() => setsname(u.u_id)}
                              className="px-3 py-1 rounded-lg bg-blue-500/20 border border-blue-400/30 text-blue-300 text-xs hover:bg-blue-500/30 transition-all">
                              Select
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {sname !== '' && (
                  <div className="mt-4 flex gap-3">
                    <input type="password" value={password} onChange={handlePasswordChange}
                      className="flex-1 bg-white/[0.05] border border-white/[0.10] rounded-xl px-4 py-2.5 text-sm text-white placeholder-white/30 focus:outline-none focus:border-blue-400/50"
                      placeholder="New Password" />
                    <button onClick={handleSubmit2}
                      className="px-4 py-2.5 rounded-xl bg-blue-600 hover:bg-blue-500 text-white text-sm font-semibold transition-all">
                      Change
                    </button>
                  </div>
                )}
              </div>
              <div className="px-6 py-4 border-t border-white/[0.15] flex justify-end">
                <button onClick={() => { SetOpen(false); setsname(''); setNameSearchTerm(''); setusersearch([]); }}
                  className="px-4 py-2 rounded-xl bg-white/[0.06] border border-white/[0.10] text-white/80 text-sm hover:bg-white/[0.10] hover:text-white transition-all">
                  Close
                </button>
              </div>
            </motion.div>
          </div>
        )}

        {/* ── Section 9: Class Management (Home) ─────────────────────────────── */}
        {section === 9 && (
          <div className="p-6 lg:p-8">
            {/* Breadcrumb */}
            <p className="text-white/55 text-xs mb-6 tracking-wide">Dashboard &rsaquo; Class Management</p>

            {/* Welcome header */}
            <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
              <div>
                <p className="text-white/65 text-sm mb-0.5">Let's kick off the class with energy!</p>
                <h1 className="text-3xl lg:text-4xl font-bold text-white">
                  Welcome back, <span className="bg-gradient-to-r from-blue-400 to-indigo-400 bg-clip-text text-transparent">{user?.first_name}</span>!
                </h1>
              </div>
              <button
                onClick={() => setIsModalOpen(true)}
                className="flex items-center gap-2 px-5 py-2.5 rounded-xl bg-blue-500/20 border border-blue-400/30 text-blue-300 text-sm font-semibold hover:bg-blue-500/30 hover:border-blue-400/50 transition-all duration-200 active:scale-[0.98] shadow-md shadow-blue-500/10 self-start sm:self-auto"
              >
                <FiPlusCircle /> New Class
              </button>
            </div>

            {/* Stats row */}
            <div className="grid grid-cols-2 gap-4 mb-8">
              <StatCard label="Total Classes" value={classlst.length} sub="active classes" accent="bg-gradient-to-r from-blue-500/60 to-blue-400/40" />
              <StatCard label="Saved Tests" value={autosave.length} sub="ready to assign" accent="bg-gradient-to-r from-indigo-500/60 to-indigo-400/40" />
            </div>

            {/* Class grid */}
            {classlst.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {classlst.map((course, idx) => (
                  <CourseCard
                    key={idx}
                    {...course}
                    course={course}
                    setsection={setsection}
                    setSelectedClass={(c) => {
                      setSelectedClass(c);
                      navigate(`/main/teacher/${c.classid}`);
                    }}
                  />
                ))}
              </div>
            ) : (
              <div className="flex flex-col items-center justify-center h-[360px] bg-white/[0.02] border border-white/[0.12] rounded-2xl text-center">
                <div className="w-16 h-16 rounded-2xl bg-white/[0.07] border border-white/[0.15] flex items-center justify-center mb-4">
                  <FaRegFrownOpen className="text-3xl text-white/45" />
                </div>
                <h2 className="text-base font-semibold text-white/50 mb-1">No classes yet</h2>
                <p className="text-white/45 text-sm mb-5">Create your first class to get started</p>
                <button
                  onClick={() => setIsModalOpen(true)}
                  className="px-5 py-2.5 rounded-xl bg-blue-500/20 border border-blue-400/30 text-blue-300 text-sm font-semibold hover:bg-blue-500/30 transition-all"
                >
                  New Class+
                </button>
              </div>
            )}
          </div>
        )}

        {/* ── Section 0: My Class Management ─────────────────────────────────── */}
        {section === 0 && (
          <MyClassManagement
            selectedClass={selectedClass}
            setSelectedClass={(c) => {
                setSelectedClass(c);
                if (c === '') navigate('/main/teacher');
              }}
            classlst={classlst}
            handleSelectChange={handleSelectChange}
            handleRemoveClass={handleRemoveClass}
            handleCopyClassId={handleCopyClassId}
            currentStudents={currentStudents}
            table={table}
            studentsPerPage={studentsPerPage}
            paginate={paginate}
            currentPage={currentPage}
            handleRemove={handleRemove}
            handleViewDashboard={handleViewDashboard}
            setsection={setsection}
            sethelpsession={sethelpsession}
            setSelectedStudentId={setSelectedStudentId}
            setIsModalOpen={setIsModalOpen}
            filteredLength={filteredLength}
            currentQuizzes={currentQuizzes}
            quizzesPerPage={quizzesPerPage}
            paginate2={paginate2}
            currentPage2={currentPage2}
            setsavedquizmodel={setsavedquizmodel}
            setquiztitle={setquiztitle}
            setquizid={setquizid}
            setquizdata={setquizdata}
            ensureQuizDataStructure={ensureQuizDataStructure}
            setquizgroup={setquizgroup}
            setquiz_type={setquiz_type}
            get_quiz_view={get_quiz_view}
            handleNavigate={handleNavigate}
            user={user}
            setquizview={setquizview}
            fetchClassList={fetchClassList}
            updateStudentList={(newList) => settable(newList)}
            filteredQuizzes={filteredQuizzes}
          />
        )}

        {/* ── Section 1: Reported Problems ───────────────────────────────────── */}
        {section === 1 && (
          <div className="p-6 lg:p-8">
            <p className="text-white/55 text-xs mb-6 tracking-wide">Dashboard &rsaquo; Reported Problems</p>
            <h1 className="text-2xl font-bold text-white mb-6">Reported Problems</h1>
            <div className="bg-white/[0.07] border border-white/[0.15] rounded-2xl overflow-hidden">
              {notes.length > 0 ? (
                <table className="w-full text-sm">
                  <thead>
                    <tr className="bg-white/[0.07] text-white/65 text-xs uppercase tracking-wider">
                      {['Note ID', 'Type', 'Question ID', 'Submitter', 'Actions'].map(h => (
                        <th key={h} className="px-5 py-3.5 text-left font-semibold">{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {notes.map((note, i) => (
                      <tr key={i} className="border-t border-white/[0.12] hover:bg-white/[0.07] transition-colors">
                        <td className="px-5 py-3 text-white/80">{note.id}</td>
                        <td className="px-5 py-3 text-white/80">{note.note.type}</td>
                        <td className="px-5 py-3 text-white/80">{note.question_id}</td>
                        <td className="px-5 py-3 text-white/80">{note.note.name}</td>
                        <td className="px-5 py-3 flex gap-2">
                          <button onClick={() => handleviewproblem(note.note.type, note.question_id)}
                            className="px-3 py-1.5 rounded-lg bg-white/[0.06] border border-white/[0.15] text-white/80 text-xs hover:bg-white/[0.10] hover:text-white transition-all">
                            View
                          </button>
                          <button onClick={() => handleremovenote(note.id)}
                            className="px-3 py-1.5 rounded-lg bg-red-500/15 border border-red-400/20 text-red-400/70 text-xs hover:bg-red-500/25 hover:text-red-400 transition-all">
                            Remove
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className="flex items-center justify-center h-40 text-white/55 text-sm">No reported problems</div>
              )}
            </div>
          </div>
        )}

        {/* ── Section 2: SAT Answers ─────────────────────────────────────────── */}
        {section === 2 && (
          <div className="p-6">
            <PaginatedTable folders={folders} setFolders={setFolders} fetchPdfs={fetchPdfs} />
          </div>
        )}

        {/* ── Section 3: Create SAT Test ─────────────────────────────────────── */}
        {section === 3 && (
          <div className="pt-6">
            <RandomSATReady setLoading={setLoading} />
          </div>
        )}

        {/* ── Section 8: Saved Tests ─────────────────────────────────────────── */}
        {section === 8 && (
          <div className="p-6 lg:p-8">
            <p className="text-white/55 text-xs mb-6 tracking-wide">Dashboard &rsaquo; Saved Tests</p>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-9 h-9 rounded-xl bg-white/[0.06] border border-white/[0.15] flex items-center justify-center">
                <FaRegNoteSticky className="text-white/50 text-sm" />
              </div>
              <h1 className="text-2xl font-bold text-white">Saved Tests</h1>
              <span className="ml-1 px-2.5 py-0.5 rounded-full bg-white/[0.06] border border-white/[0.15] text-white/65 text-xs font-semibold">
                {autosave.length}
              </span>
            </div>

            {autosave.length > 0 ? (
              <>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                  {currentQuizzes2.map((test) => {
                    const numq = JSON.parse(test.quiz_data)?.questions?.length;
                    const formattedDate = new Date(test.created_date).toLocaleDateString();
                    const subject = detectTestSubject(test);
                    return (
                      <div key={test.testid}
                        className="relative bg-white/[0.07] border border-white/[0.15] backdrop-blur-sm rounded-2xl p-5 hover:bg-white/[0.07] hover:border-white/[0.14] transition-all duration-300 group">
                        <div className={`absolute top-0 left-0 right-0 h-0.5 rounded-t-2xl ${test.status === 'released' ? 'bg-gradient-to-r from-violet-500/70 to-purple-500/70' : 'bg-gradient-to-r from-blue-500/70 to-indigo-500/70'}`} />

                        <div className="flex items-start justify-between mb-3">
                          <h3 className="text-base font-bold text-white truncate pr-2 flex-1">{test.name}</h3>
                          <div className="flex items-center gap-1.5 flex-shrink-0">
                            {subject && (
                              <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider ${
                                subject === 'Math'
                                  ? 'bg-blue-500/20 border border-blue-400/35 text-blue-300'
                                  : 'bg-emerald-500/20 border border-emerald-400/35 text-emerald-300'
                              }`}>
                                {subject === 'Math' ? '📐 Math' : '📖 English'}
                              </span>
                            )}
                            <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider ${
                              test.status === 'released'
                                ? 'bg-violet-500/20 border border-violet-400/35 text-violet-300'
                                : 'bg-amber-500/15 border border-amber-400/30 text-amber-300'
                            }`}>
                              {test.status === 'released' ? '🔒 Released' : 'Draft'}
                            </span>
                          </div>
                        </div>

                        <div className="space-y-2 mb-4">
                          {[
                            { label: 'Type', value: test.type },
                            { label: 'Questions', value: numq },
                            { label: 'Created', value: formattedDate },
                          ].map(({ label, value }) => (
                            <div key={label} className="flex items-center justify-between">
                              <span className="text-white/35 text-xs">{label}</span>
                              <span className="text-white/65 text-xs font-medium">{value}</span>
                            </div>
                          ))}
                        </div>

                        <div className="flex flex-col gap-2 pt-3 border-t border-white/[0.07]">
                          <div className="flex gap-2">
                            <button
                              onClick={() => { setsavedquizmodel(true); setquiztitle(test.name); setquizid(test.testid); setquizdata(ensureQuizDataStructure(test.quiz_data)); setquizgroup(test.quiz_group); setquiz_type(test.type); }}
                              className="flex-1 py-1.5 rounded-lg bg-white/[0.06] border border-white/[0.15] text-white/75 text-xs font-medium hover:bg-white/[0.10] hover:text-white transition-all">
                              Setting
                            </button>
                            <button
                              onClick={() => { setquizview(true); setquiztitle(test.name); setquizid(test.testid); setquizdata(ensureQuizDataStructure(test.quiz_data)); setquizgroup(test.quiz_group); setquiz_type(test.type); get_quiz_view(test.testid); }}
                              className="flex-1 py-1.5 rounded-lg bg-white/[0.06] border border-white/[0.15] text-white/75 text-xs font-medium hover:bg-white/[0.10] hover:text-white transition-all">
                              View
                            </button>
                            <button
                              onClick={() => { setquiz_type(test.type); handleNavigate(test.testid); }}
                              className="flex-1 py-1.5 rounded-lg bg-blue-500/20 border border-blue-400/30 text-blue-300 text-xs font-medium hover:bg-blue-500/30 transition-all">
                              Resume
                            </button>
                          </div>
                          <button
                            onClick={() => navigate(`/main/teacher/${urlClassId || 'general'}/pdf/${test.testid}`, { state: { test } })}
                            className="w-full py-1.5 rounded-lg bg-violet-500/20 border border-violet-400/30 text-violet-300 text-xs font-semibold hover:bg-violet-500/30 hover:text-violet-200 transition-all tracking-wide">
                            PDF Worksheet
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div className="flex justify-center mt-6 gap-2">
                  {Array.from({ length: Math.ceil(autosave.length / quizzesPerPage) }, (_, i) => (
                    <button key={i} onClick={() => paginate2(i + 1)}
                      className={`w-9 h-9 rounded-xl border text-sm font-semibold transition-all duration-200 ${
                        currentPage2 === i + 1
                          ? 'bg-blue-500/25 border-blue-400/40 text-blue-300 shadow-sm shadow-blue-500/20'
                          : 'bg-white/[0.07] border-white/[0.10] text-white/65 hover:bg-white/[0.09] hover:text-white'
                      }`}>
                      {i + 1}
                    </button>
                  ))}
                </div>
              </>
            ) : (
              <div className="flex flex-col items-center justify-center h-[360px] bg-white/[0.02] border border-white/[0.12] rounded-2xl text-center">
                <div className="w-16 h-16 rounded-2xl bg-white/[0.07] border border-white/[0.15] flex items-center justify-center mb-4">
                  <FaRegFrownOpen className="text-3xl text-white/45" />
                </div>
                <h2 className="text-base font-semibold text-white/50 mb-1">No Saved Tests</h2>
                <p className="text-white/45 text-sm mb-5">Create a test to get started</p>
                <button onClick={() => setsection(3)}
                  className="px-5 py-2.5 rounded-xl bg-white/[0.06] border border-white/[0.15] text-white/80 text-sm font-semibold hover:bg-white/[0.10] hover:text-white transition-all">
                  Open Test Creator
                </button>
              </div>
            )}
          </div>
        )}

        {/* ── Quiz overview slide-in ─────────────────────────────────────────── */}
        {quizview && (
          <div className="fixed inset-0 z-[80]">
            <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
            <div className="absolute top-0 right-0 w-[48%] h-full bg-[#111827] border-l border-white/[0.15] shadow-2xl overflow-y-auto">
              <div className="flex items-center justify-between bg-[#0d1117] border-b border-white/[0.15] px-5 py-3">
                <h2 className="text-white font-bold text-lg">{quiztitle}: Overview</h2>
                <button onClick={() => { setquizview(false); setviewmodule2(false); setSelectedOption("totalQuestions"); setCorrectnessSort(null); }}
                  className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-white/[0.06] border border-white/[0.15] text-white/80 text-sm hover:bg-white/[0.10] hover:text-white transition-all">
                  <FaTimes className="text-xs" /> Close
                </button>
              </div>

              {/* Tab bar */}
              <div className="flex border-b border-white/[0.15]">
                {['totalQuestions', 'scores'].map((tab) => (
                  <button key={tab} onClick={() => handleClick(tab)}
                    className={`flex-1 py-3 text-sm font-medium transition-all ${
                      selectedOption === tab
                        ? 'text-blue-300 border-b-2 border-blue-400 bg-blue-500/5'
                        : 'text-white/65 hover:text-white/70'
                    }`}>
                    {tab === 'totalQuestions' ? 'Total Questions' : 'Scores'}
                  </button>
                ))}
              </div>

              <div className="p-5">
                {selectedOption === 'totalQuestions' ? (
                  <div className="bg-white/[0.03] border border-white/[0.07] rounded-xl overflow-hidden">
                    <table className="w-full text-sm">
                      <thead>
                        <tr className="bg-white/[0.07] text-white/65 text-xs uppercase">
                          <th className="px-4 py-3 text-left font-semibold">#</th>
                          <th className="px-4 py-3 text-left font-semibold">Skills</th>
                          <th className="px-4 py-3 text-left font-semibold">Correct Answer</th>
                          <th className="px-4 py-3 text-left font-semibold">
                            <div className="flex items-center gap-1.5">
                              Correctness
                              <button
                                onClick={() => setCorrectnessSort(s => s === 'asc' ? 'desc' : s === 'desc' ? null : 'asc')}
                                title={correctnessSort === 'asc' ? 'Low → High' : correctnessSort === 'desc' ? 'High → Low' : 'Sort'}
                                className="flex flex-col gap-px opacity-60 hover:opacity-100 transition-opacity"
                              >
                                <span style={{ fontSize: 8, lineHeight: 1, color: correctnessSort === 'asc' ? '#60a5fa' : 'rgba(255,255,255,0.45)' }}>▲</span>
                                <span style={{ fontSize: 8, lineHeight: 1, color: correctnessSort === 'desc' ? '#60a5fa' : 'rgba(255,255,255,0.45)' }}>▼</span>
                              </button>
                            </div>
                          </th>
                          <th className="px-4 py-3 text-left font-semibold">View</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sortedQuestionIndices.map((index) => {
                          const questionId = quizdata.questions[index];
                          const rawAnswer = quizdata.qrealanswers?.[index] || "[]";
                          let displayAnswer = rawAnswer;
                          try {
                            const parsed = JSON.parse(rawAnswer);
                            displayAnswer = Array.isArray(parsed) ? parsed.map(i => String(i).trim()).join(", ") : String(parsed).trim();
                          } catch {}
                          const pct = correctnessData[index];
                          const pctColor = pct == null ? 'rgba(255,255,255,0.25)' : pct >= 70 ? '#4ade80' : pct >= 40 ? '#facc15' : '#f87171';
                          return (
                            <tr key={index} className="border-t border-white/[0.12] hover:bg-white/[0.07] transition-colors">
                              <td className="px-4 py-2.5 text-white/50">{index + 1}</td>
                              <td className="px-4 py-2.5 text-white/80 text-xs">{quizdata.qskillsets[index]}</td>
                              <td className="px-4 py-2.5 text-white/80 text-xs">{displayAnswer}</td>
                              <td className="px-4 py-2.5">
                                {pct == null ? (
                                  <span className="text-white/25 text-xs">No data</span>
                                ) : (
                                  <div className="flex items-center gap-2" style={{ minWidth: 120 }}>
                                    <div className="flex-1 h-1.5 rounded-full overflow-hidden" style={{ background: 'rgba(255,255,255,0.08)' }}>
                                      <div className="h-full rounded-full transition-all duration-300" style={{ width: `${pct}%`, background: pctColor }} />
                                    </div>
                                    <span className="text-xs font-semibold" style={{ color: pctColor, minWidth: 34, textAlign: 'right' }}>{pct}%</span>
                                  </div>
                                )}
                              </td>
                              <td className="px-4 py-2.5">
                                <button onClick={() => { setviewmodule2(true); handleButtonClick(questionId, quiz_type, quizdata.questions[index].section); }}
                                  className="text-blue-400 hover:text-blue-300 text-xs font-medium">View</button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="bg-white/[0.03] border border-white/[0.07] rounded-xl overflow-hidden">
                    <table className="w-full text-sm">
                      <thead>
                        <tr className="bg-white/[0.07] text-white/65 text-xs uppercase">
                          {['Student', 'Date', 'Score', 'View'].map(h => (
                            <th key={h} className="px-4 py-3 text-left font-semibold">{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {getstudentsscores.map((obj, index) => {
                          const correct = JSON.parse(obj.testresult.Correct_questionIds || "[]").length;
                          const incorrect = JSON.parse(obj.testresult.Incorrect_questionIds || "[]").length;
                          const score = correct + incorrect > 0 ? Math.round((correct / (correct + incorrect)) * 100) : 0;
                          return (
                            <tr key={index} className="border-t border-white/[0.12] hover:bg-white/[0.07] transition-colors">
                              <td className="px-4 py-2.5 text-white/70">{obj.testresult.user_name}</td>
                              <td className="px-4 py-2.5 text-white/50 text-xs">{obj.testresult.date}</td>
                              <td className="px-4 py-2.5 text-white/70">{score}%</td>
                              <td className="px-4 py-2.5">
                                <button onClick={() => { setselectstudent(obj.testresult.user_name); setSelectedTest(obj.testresult); }}
                                  className="text-blue-400 hover:text-blue-300 text-xs font-medium">View</button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* ── Section 6: Student Dashboard View ─────────────────────────────── */}
        {section === 6 && isDashboardOpen && (
          <div className="bg-[#0d1117]">
            <div className="ml-[-240px]">
              <div className="flex justify-end items-center bg-[#111827] border-b border-white/[0.15] px-4 py-3">
                <button onClick={() => { handleClose(); setsection(0); }}
                  className="px-4 py-2 rounded-xl bg-white/[0.06] border border-white/[0.15] text-white/80 text-sm hover:bg-white/[0.10] hover:text-white transition-all">
                  Back
                </button>
              </div>
              <Dashboard s_uid={selectedStudentId} smallmode={true} />
            </div>
          </div>
        )}

        {/* ── Section 7: Help Session ────────────────────────────────────────── */}
        {section === 7 && helpsession && (
          <div>
            <div className="ml-[-240px]">
              <div className="flex justify-end items-center bg-[#111827] border-b border-white/[0.15] px-4 py-3">
                <button onClick={() => { handleClose(); setsection(0); }}
                  className="px-4 py-2 rounded-xl bg-white/[0.06] border border-white/[0.15] text-white/80 text-sm hover:bg-white/[0.10] hover:text-white transition-all">
                  Back
                </button>
              </div>
              <div className="ml-[240px] mr-[10px]">
                <GetHelp studentid={selectedStudentId} setsection={setsection} selectedClass={selectedClass} />
              </div>
            </div>
          </div>
        )}

        {/* ── Question viewer (viewmodule2) ──────────────────────────────────── */}
        {viewmodule2 && (
          <div className="fixed inset-0 z-[81] pointer-events-none">
            <div className={`absolute top-0 left-0 ${isExpanded ? 'w-full' : 'w-1/2'} h-full bg-[#111827] border-r border-white/[0.15] shadow-2xl overflow-y-auto pointer-events-auto transition-all duration-300`}>
              {/* Nav bar */}
              <div className="flex items-center justify-between bg-[#0d1117] border-b border-white/[0.15] px-4 py-2.5">
                <div className="flex items-center gap-2">
                  <button onClick={handlePreviousQuestion} className="px-3 py-1.5 rounded-lg bg-white/[0.06] border border-white/[0.15] text-white/80 text-xs hover:bg-white/[0.10] hover:text-white transition-all">&lt; Prev</button>
                  <button onClick={handleNextQuestion} className="px-3 py-1.5 rounded-lg bg-white/[0.06] border border-white/[0.15] text-white/80 text-xs hover:bg-white/[0.10] hover:text-white transition-all">Next &gt;</button>
                </div>
                <p className="text-white/50 text-xs font-medium">{quiz_type} | Question</p>
                <div className="flex items-center gap-2">
                  <label className="flex items-center gap-1.5 cursor-pointer">
                    <input type="checkbox" checked={hideExplanation} onChange={modulehandleChange} className="w-3.5 h-3.5 rounded" />
                    <span className="text-white/65 text-xs">Hide Explanation</span>
                  </label>
                  <button onClick={() => setIsExpanded(!isExpanded)} className="p-1.5 rounded-lg bg-white/[0.06] border border-white/[0.15] text-white/50 hover:text-white transition-all">
                    {isExpanded ? <FaAnglesLeft className="text-xs" /> : <FaAnglesRight className="text-xs" />}
                  </button>
                  <button onClick={() => setviewmodule2(false)} className="p-1.5 rounded-lg bg-red-500/15 border border-red-400/20 text-red-400/70 hover:text-red-400 hover:bg-red-500/25 transition-all">
                    <FaTimes className="text-xs" />
                  </button>
                </div>
              </div>

              {/* Content */}
              <div className="flex flex-1 overflow-y-auto h-[calc(100%-48px)]">
                <div className="w-1/2 p-5 overflow-y-auto border-r border-gray-200" style={{ background: "#ffffff" }}>
                  <div dangerouslySetInnerHTML={{ __html: selectedTopic.stem }} className="text-gray-800 text-sm" />
                  <div dangerouslySetInnerHTML={{ __html: selectedTopic.stimulus }} className="text-gray-700 text-sm mt-4" />
                </div>
                <div className="w-1/2 p-5 overflow-y-auto" style={{ background: "#ffffff" }}>
                  <div className="bg-gray-100 border border-gray-200 rounded-xl p-3 mb-3">
                    <p className="text-gray-500 text-xs font-semibold uppercase tracking-wider">Question Review</p>
                  </div>
                  <div className="mb-3">
                    {selectedTopic.a != null ? (
                      <>
                        <Option idx={0} data={selectedTopic.a} />
                        <Option idx={1} data={selectedTopic.b} />
                        <Option idx={2} data={selectedTopic.c} />
                        <Option idx={3} data={selectedTopic.d} />
                      </>
                    ) : (
                      <input className="w-full bg-gray-100 border border-gray-200 rounded-xl px-4 py-2.5 text-gray-800 text-sm focus:outline-none focus:border-blue-400" type="text" />
                    )}
                  </div>
                  {!hideExplanation && (
                    <div className="mt-4 p-4 bg-blue-50 border border-blue-100 rounded-xl">
                      <div dangerouslySetInnerHTML={{ __html: selectedTopic.rationale2 ? selectedTopic.rationale2 : selectedTopic.rationale }} className="text-gray-700 text-sm" />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ── Student report card slide-in ───────────────────────────────────── */}
        {selectstudent !== '' && (
          <div className="fixed inset-0 z-[80]">
            <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
            <div className="absolute top-0 right-0 w-[48%] h-full bg-[#111827] border-l border-white/[0.15] shadow-2xl overflow-y-auto">
              <div className="flex items-center justify-between bg-[#0d1117] border-b border-white/[0.15] px-5 py-3">
                <p className="text-white font-bold text-lg">{selectstudent}'s Report Card</p>
                <button onClick={() => setselectstudent('')}
                  className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-white/[0.06] border border-white/[0.15] text-white/80 text-sm hover:bg-white/[0.10] hover:text-white transition-all">
                  <FaTimes className="text-xs" /> Close
                </button>
              </div>
              <div className="p-5">
                <h2 className="text-white font-bold text-lg mb-4">Test Question Overview</h2>
                <div className="bg-white/[0.03] border border-white/[0.07] rounded-xl overflow-hidden overflow-x-auto">
                  <table className="w-full text-sm">
                    <thead>
                      <tr className="bg-white/[0.07] text-white/65 text-xs uppercase">
                        {['#', 'Section', 'Correct Answer', 'Your Answer', 'View'].map(h => (
                          <th key={h} className="px-4 py-3 text-left font-semibold">{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {JSON.parse(selectedTest.quiz_data).map((question, index) => {
                        const rawAnswer = quizdata.qrealanswers?.[index] || "[]";
                        let displayAnswer = rawAnswer;
                        try {
                          const parsed = JSON.parse(rawAnswer);
                          displayAnswer = Array.isArray(parsed) ? parsed.map(i => String(i).trim()).join(", ") : String(parsed).trim();
                        } catch {}

                        if (question && question.section !== 'frq') {
                          return (
                            <tr key={index} className={`border-t border-white/[0.12] transition-colors ${question.correct ? 'hover:bg-white/[0.07]' : 'bg-red-500/10 hover:bg-red-500/15'}`}>
                              <td className="px-4 py-2.5 text-white/50">{index + 1}</td>
                              <td className="px-4 py-2.5 text-white/80 text-xs">{question.topic} {question.category}</td>
                              <td className="px-4 py-2.5 text-white/80 text-xs capitalize">{displayAnswer}</td>
                              <td className="px-4 py-2.5 text-white/80 text-xs">{question.selectedOption || 'Omitted'}</td>
                              <td className="px-4 py-2.5">
                                <button onClick={() => { setviewmodule2(true); handleButtonClick(question.questionIds, quiz_type, quizdata.questions[index].section); }}
                                  className="text-blue-400 hover:text-blue-300 text-xs font-medium">View</button>
                              </td>
                            </tr>
                          );
                        }
                        return (
                          <tr key={index} className={`border-t border-white/[0.12] ${question.correct ? '' : 'bg-red-500/10'}`}>
                            <td className="px-4 py-2.5 text-white/50">{index + 1}</td>
                            <td className="px-4 py-2.5 text-white/80 text-xs">{question.topic} {question.category}</td>
                            <td className="px-4 py-2.5 text-white/65 text-xs">FRQ content</td>
                            <td className="px-4 py-2.5 text-white/65 text-xs">Click view</td>
                            <td className="px-4 py-2.5 text-white/65 text-xs">—</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ── Create class modal ─────────────────────────────────────────────── */}
        {isModalOpen && (
          <CreateClassModal
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            handleCreateClass={handleCreateClass}
          />
        )}

        {/* ── Saved quiz settings modal ──────────────────────────────────────── */}
        {savedquizmodel && (
          <SavedTestModal
            quiztitle={quiztitle}
            setquiztitle={setquiztitle}
            quizgroup={quizgroup}
            setquizgroup={setquizgroup}
            quizdata={quizdata}
            quiz_type={quiz_type}
            classlst={classlst}
            onSave={handleSave}
            onRemove={handleRemoveQuiz}
            onClose={() => setsavedquizmodel(false)}
          />
        )}

        {/* ── Password reset modal ───────────────────────────────────────────── */}
        {isOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm px-4">
            <motion.div initial={{ opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: 1 }}
              className="w-full max-w-sm bg-[#111827] border border-white/[0.10] rounded-2xl shadow-2xl overflow-hidden">
              <div className="px-6 py-5 border-b border-white/[0.15]">
                <h3 className="text-lg font-bold text-white">Password Reset</h3>
              </div>
              <div className="p-6">
                <input type="password" value={password} onChange={handlePasswordChange}
                  className="w-full bg-white/[0.05] border border-white/[0.10] rounded-xl px-4 py-2.5 text-white text-sm placeholder-white/30 focus:outline-none focus:border-blue-400/50"
                  placeholder="New password…" />
              </div>
              <div className="px-6 py-4 border-t border-white/[0.15] flex justify-end gap-2">
                <button onClick={passwordhandleSubmit}
                  className="px-4 py-2 rounded-xl bg-blue-600 hover:bg-blue-500 text-white text-sm font-semibold transition-all">Submit</button>
                <button onClick={() => setIsOpen(false)}
                  className="px-4 py-2 rounded-xl bg-white/[0.06] border border-white/[0.10] text-white/80 text-sm hover:bg-white/[0.10] hover:text-white transition-all">Cancel</button>
              </div>
            </motion.div>
          </div>
        )}

        {/* ── Premium activation modal ───────────────────────────────────────── */}
        <Modal
          isOpen={isPremiumModalOpen}
          onRequestClose={() => setIsPremiumModalOpen(false)}
          contentLabel="Go Premium Modal"
          className="absolute bg-[#111827] border border-white/[0.10] p-6 rounded-2xl shadow-2xl max-w-md mx-auto mt-24 outline-none"
          overlayClassName="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-start z-[60]"
        >
          <h2 className="text-lg font-bold text-white mb-1">Go Premium</h2>
          <p className="text-white/65 text-sm mb-4">Enter your coupon code to activate:</p>
          <input type="text" value={couponCode} onChange={(e) => setCouponCode(e.target.value)}
            className="w-full bg-white/[0.05] border border-white/[0.10] rounded-xl px-4 py-2.5 text-white text-sm placeholder-white/30 focus:outline-none focus:border-blue-400/50 mb-3"
            placeholder="Enter Coupon Code" />
          <p className="text-white/55 text-xs mb-4">Need a code? Contact <a href="mailto:angiek@mmtprep.com" className="text-blue-400 hover:underline">angiek@mmtprep.com</a></p>
          {isCouponValid !== null && (
            <p className={`text-sm mb-3 font-medium ${isCouponValid ? 'text-emerald-400' : 'text-red-400'}`}>
              {isCouponValid ? 'Coupon code is valid!' : 'Invalid coupon code.'}
            </p>
          )}
          <div className="flex gap-2 justify-end">
            <button onClick={handleVerifyCoupon} disabled={isVerifying}
              className="px-4 py-2 rounded-xl bg-blue-600 hover:bg-blue-500 text-white text-sm font-semibold transition-all disabled:opacity-50">
              {isVerifying ? 'Verifying…' : 'Verify Coupon'}
            </button>
            <button onClick={() => setIsPremiumModalOpen(false)}
              className="px-4 py-2 rounded-xl bg-white/[0.06] border border-white/[0.10] text-white/80 text-sm hover:bg-white/[0.10] hover:text-white transition-all">
              Cancel
            </button>
          </div>
        </Modal>

        {/* ── Settings modal ─────────────────────────────────────────────────── */}
        <SettingModal
          isOpen={isOpen2}
          onClose={() => setIsOpen2(false)}
          user={user}
          onSave={handleSave}
          onLogout={onLogout}
        />

      </div>
    </>
  );
};

export default TDashboard;

// ─── Option component ────────────────────────────────────────────────────────
const Option = ({ idx, data }) => (
  <div className="flex flex-row gap-1 mb-1">
    <motion.div whileTap={{ scale: 0.98 }}
      className="flex flex-row w-full bg-gray-50 border border-gray-200 rounded-xl gap-2 p-2.5 cursor-pointer hover:bg-gray-100 transition-all">
      <div className="flex items-center flex-shrink-0">
        <p className="flex items-center justify-center w-6 h-6 border border-gray-300 rounded-full text-gray-500 text-xs font-semibold">
          {getOptionLetter(idx)}
        </p>
      </div>
      <div dangerouslySetInnerHTML={{ __html: data }} className="text-gray-700 text-sm" />
    </motion.div>
  </div>
);

function getOptionLetter(idx) {
  return ['A', 'B', 'C', 'D'][idx] ?? 'A';
}

// ─── Saved Test Modal ────────────────────────────────────────────────────────
function SavedTestModal({ quiztitle, setquiztitle, quizgroup, setquizgroup, quizdata, quiz_type, classlst, onSave, onRemove, onClose }) {
  const [confirmDelete, setConfirmDelete] = React.useState(false);

  const assignedNames = new Set(
    Array.isArray(quizgroup) ? quizgroup.map(g => g.class_name) : []
  );

  const toggleClass = (cls) => {
    const current = Array.isArray(quizgroup) ? quizgroup : [];
    const already = current.some(g => g.class_name === cls.class_name);
    setquizgroup(already ? current.filter(g => g.class_name !== cls.class_name) : [...current, cls]);
  };

  const numQ = quizdata?.questions?.length ?? 0;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4"
      style={{ background: "rgba(0,0,0,0.72)", backdropFilter: "blur(10px)" }}
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <motion.div
        initial={{ opacity: 0, y: 14, scale: 0.97 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: 8, scale: 0.97 }}
        transition={{ duration: 0.2, ease: [0.16, 1, 0.3, 1] }}
        className="w-full max-w-md rounded-2xl overflow-hidden"
        style={{ background: "#12151f", border: "1px solid rgba(255,255,255,0.09)", boxShadow: "0 32px 64px rgba(0,0,0,0.6)" }}
      >
        {/* Top shimmer */}
        <div className="absolute top-0 left-0 right-0" style={{ height: "1px", background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.15), transparent)" }} />

        {/* Header */}
        <div className="flex items-start justify-between px-6 pt-6 pb-4" style={{ borderBottom: "1px solid rgba(255,255,255,0.07)" }}>
          <div>
            <h2 className="text-base font-bold text-white">Test Settings</h2>
            <div className="flex items-center gap-2 mt-1">
              <span className="text-xs px-2 py-0.5 rounded-full font-semibold"
                style={{ background: "rgba(37,99,235,0.20)", border: "1px solid rgba(96,165,250,0.28)", color: "#93c5fd" }}>
                {quiz_type || "SAT"}
              </span>
              <span className="text-xs" style={{ color: "rgba(255,255,255,0.30)" }}>
                {numQ} question{numQ !== 1 ? 's' : ''}
              </span>
            </div>
          </div>
          <button onClick={onClose}
            className="p-1.5 rounded-lg transition-all mt-0.5"
            style={{ color: "rgba(255,255,255,0.28)" }}
            onMouseEnter={e => { e.currentTarget.style.background = "rgba(255,255,255,0.07)"; e.currentTarget.style.color = "rgba(255,255,255,0.70)"; }}
            onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = "rgba(255,255,255,0.28)"; }}>
            <FaTimes size={12} />
          </button>
        </div>

        {/* Body */}
        <div className="px-6 pt-5 pb-6 space-y-5">
          {/* Test Name */}
          <div>
            <label className="block text-xs font-semibold uppercase tracking-widest mb-2"
              style={{ color: "rgba(255,255,255,0.30)" }}>Test Name</label>
            <input
              type="text"
              value={quiztitle}
              onChange={e => setquiztitle(e.target.value)}
              className="w-full rounded-xl px-4 py-2.5 text-sm text-white outline-none transition-all"
              style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.09)", caretColor: "white" }}
              onFocus={e => e.target.style.border = "1px solid rgba(255,255,255,0.28)"}
              onBlur={e => e.target.style.border = "1px solid rgba(255,255,255,0.09)"}
            />
          </div>

          {/* Assign to Classes */}
          <div>
            <label className="block text-xs font-semibold uppercase tracking-widest mb-2.5"
              style={{ color: "rgba(255,255,255,0.30)" }}>
              Assign to Classes
            </label>
            {classlst.length > 0 ? (
              <div className="space-y-2 max-h-48 overflow-y-auto pr-1">
                {classlst.map(cls => {
                  const active = assignedNames.has(cls.class_name);
                  return (
                    <button
                      key={cls.classid}
                      type="button"
                      onClick={() => toggleClass(cls)}
                      className="w-full flex items-center justify-between px-4 py-2.5 rounded-xl transition-all text-left"
                      style={{
                        background: active ? "rgba(37,99,235,0.15)" : "rgba(255,255,255,0.03)",
                        border: active ? "1px solid rgba(96,165,250,0.35)" : "1px solid rgba(255,255,255,0.07)",
                      }}
                      onMouseEnter={e => { if (!active) e.currentTarget.style.background = "rgba(255,255,255,0.06)"; }}
                      onMouseLeave={e => { if (!active) e.currentTarget.style.background = "rgba(255,255,255,0.03)"; }}
                    >
                      <div>
                        <p className="text-sm font-medium" style={{ color: active ? "#93c5fd" : "rgba(255,255,255,0.70)" }}>
                          {cls.class_name}
                        </p>
                        <p className="text-xs mt-0.5" style={{ color: "rgba(255,255,255,0.28)" }}>
                          {cls.typeclass} · Code: {cls.shortid}
                        </p>
                      </div>
                      <div className="flex-shrink-0 w-5 h-5 rounded-md flex items-center justify-center transition-all"
                        style={{
                          background: active ? "rgba(37,99,235,0.50)" : "rgba(255,255,255,0.05)",
                          border: active ? "1px solid rgba(96,165,250,0.50)" : "1px solid rgba(255,255,255,0.12)",
                        }}>
                        {active && <FiCheck size={11} strokeWidth={3} color="white" />}
                      </div>
                    </button>
                  );
                })}
              </div>
            ) : (
              <div className="py-6 text-center rounded-xl" style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.06)" }}>
                <p className="text-sm" style={{ color: "rgba(255,255,255,0.30)" }}>No classes yet — create a class first</p>
              </div>
            )}
          </div>

          {/* Delete confirm inline */}
          {confirmDelete ? (
            <div className="rounded-xl p-4" style={{ background: "rgba(239,68,68,0.10)", border: "1px solid rgba(239,68,68,0.22)" }}>
              <p className="text-sm font-semibold mb-3" style={{ color: "#f87171" }}>Delete this test permanently?</p>
              <div className="flex gap-2">
                <button onClick={onRemove}
                  className="flex-1 py-2 rounded-xl text-sm font-bold transition-all"
                  style={{ background: "rgba(239,68,68,0.30)", border: "1px solid rgba(239,68,68,0.40)", color: "#f87171" }}>
                  Yes, Delete
                </button>
                <button onClick={() => setConfirmDelete(false)}
                  className="flex-1 py-2 rounded-xl text-sm font-medium transition-all"
                  style={{ background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.09)", color: "rgba(255,255,255,0.55)" }}>
                  Cancel
                </button>
              </div>
            </div>
          ) : (
            <div className="flex items-center gap-2 pt-1">
              <button onClick={onSave}
                className="flex-1 py-2.5 rounded-xl text-sm font-bold text-white transition-all active:scale-[0.98]"
                style={{ background: "linear-gradient(135deg, #1d4ed8 0%, #4f46e5 100%)", boxShadow: "0 4px 18px rgba(29,78,216,0.30)" }}>
                Save Changes
              </button>
              <button onClick={() => setConfirmDelete(true)}
                className="px-4 py-2.5 rounded-xl text-sm font-semibold transition-all"
                style={{ background: "rgba(239,68,68,0.10)", border: "1px solid rgba(239,68,68,0.20)", color: "rgba(239,68,68,0.70)" }}
                onMouseEnter={e => { e.currentTarget.style.background = "rgba(239,68,68,0.22)"; e.currentTarget.style.color = "#f87171"; }}
                onMouseLeave={e => { e.currentTarget.style.background = "rgba(239,68,68,0.10)"; e.currentTarget.style.color = "rgba(239,68,68,0.70)"; }}>
                Delete
              </button>
            </div>
          )}
        </div>
      </motion.div>
    </div>
  );
}
